import createRequestValidationForm from "@serie3/common/Form/Register/RequestValidationForm";
import { useFormik } from "formik";
import { useState } from "react";
import FreelancerserplaceNavbar from "../signup/SubComponents/FreelancerserplaceNavbar";
import Footer from "../signup/SubComponents/Footer";

const RequestValidationLink = ({ setToken }) => {
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const requestValidationForm = createRequestValidationForm((val) => {
    setSuccess(val);
    setLoading(false);
  });
  const formik = useFormik({
    ...requestValidationForm,
    onSubmit: (values, actions) => {
      setLoading(true);
      requestValidationForm.onSubmit(values, actions);
    },
  });

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", background: "#f5f7fa" }}>
      <FreelancerserplaceNavbar setToken={setToken} showButtons={false} showLinks={false} />

      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 16px" }}>
        <div style={{
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
          padding: "40px 36px",
          width: "100%",
          maxWidth: "440px",
        }}>
          {/* Icon */}
          <div style={{
            width: "56px", height: "56px", borderRadius: "14px",
            background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
            marginBottom: "24px",
            boxShadow: "0 4px 14px rgba(26,115,232,0.3)",
          }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
          </div>

          <h1 style={{ fontSize: "1.4rem", fontWeight: 800, color: "#212121", marginBottom: "8px" }}>
            Verify your email
          </h1>
          <p style={{ fontSize: "0.9rem", color: "#757575", marginBottom: "28px", lineHeight: 1.6 }}>
            Your email address hasn't been verified yet. Check your inbox for the validation link, or request a new one below.
          </p>

          {success === null && (
            <form onSubmit={formik.handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <label style={{
                  display: "block", fontSize: "0.78rem", fontWeight: 700,
                  textTransform: "uppercase", letterSpacing: "0.07em",
                  color: "#9e9e9e", marginBottom: "7px",
                }}>
                  Email address
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: "100%", padding: "10px 14px",
                    border: "1px solid #e0e0e0", borderRadius: "9px",
                    fontSize: "0.95rem", color: "#212121",
                    background: "#fff", outline: "none", boxSizing: "border-box",
                    transition: "border-color 0.15s",
                  }}
                  onFocus={(e) => { e.target.style.borderColor = "#1a73e8"; }}
                  onBlurCapture={(e) => { e.target.style.borderColor = "#e0e0e0"; }}
                />
              </div>

              <button
                type="submit"
                disabled={loading || !formik.values.email}
                style={{
                  width: "100%", padding: "11px 0",
                  background: loading || !formik.values.email ? "#b0c8f5" : "#1a73e8",
                  color: "#fff", border: "none", borderRadius: "9px",
                  fontSize: "0.95rem", fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
                  display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                  transition: "background 0.15s",
                }}
              >
                {loading ? (
                  <>
                    <span style={{
                      width: "15px", height: "15px", border: "2px solid rgba(255,255,255,0.4)",
                      borderTopColor: "#fff", borderRadius: "50%",
                      animation: "spin 0.75s linear infinite", display: "inline-block",
                    }} />
                    Sending…
                  </>
                ) : "Send verification link"}
              </button>
            </form>
          )}

          {success === true && (
            <div style={{
              display: "flex", flexDirection: "column", alignItems: "center",
              gap: "12px", padding: "24px 0",
            }}>
              <div style={{
                width: "48px", height: "48px", borderRadius: "50%",
                background: "#e8f5e9", display: "flex", alignItems: "center", justifyContent: "center",
              }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2e7d32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <div style={{ fontWeight: 700, fontSize: "1rem", color: "#212121" }}>Link sent!</div>
              <div style={{ fontSize: "0.88rem", color: "#757575", textAlign: "center", lineHeight: 1.6 }}>
                If we recognise your email, a new verification link has been sent. It is valid for <strong>1 hour</strong>.
              </div>
            </div>
          )}

          {success === false && (
            <div style={{
              marginTop: "16px", padding: "12px 16px",
              background: "#ffebee", borderRadius: "9px",
              fontSize: "0.88rem", color: "#c62828", fontWeight: 500,
            }}>
              Something went wrong. Please try again.
            </div>
          )}
        </div>
      </div>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <Footer />
    </div>
  );
};

export default RequestValidationLink;
